import { writable } from "svelte/store"
import Posts from "./Posts.svelte"

export const page = writable({ component: Posts, data: {} })
export const apiKey = writable(localStorage.getItem("apiKey"))
